import ApiService from './api.service'

const FormResultService = {

  /***
   * Get account via slug
   * @param {string} slug identifier of the account
   * @param {string} params.type defaults to 'plat' on the server if left blank
   * @returns {*}
   */
  get (slug) {
    return ApiService.query(`form-result/${slug}`)
  },
  /***
   * Get all form results for own/specific organization
   * @param {string} params.fk_organization_key identifier of the
   * organization that owns the accounts, defaults to self if blank
   * @returns {*}
   */
  getMany (slug, params) {
    return ApiService.query(`form-result/${slug}`, params)
  },
  /***
   * Get all form results for own/specific organization
   * @param {string} slug the rowkey of the form to flag as processed
   * @returns {*}
   */
  markProcessed (slug) {
    const params = {
      is_processed: true,
    }
    return ApiService.post(`form-result/${slug}`, params)
  },
  /***
   * Mark a form-result as deleted
   * @param {string} slug the rowkey of the form to flag as processed
   * @returns {*}
   */
  deleteResult (slug) {
    return ApiService.post(`form-result/${slug}/delete`)
  },
  /***
   * Send email to request e-signature for form result
   * @param {string} slug the rowkey of the form result assigned we want to send
   * @param {string} params.email_address email address for recipient
   * @returns {*}
   */
  requestSignature (slug, params) {
    const payload = {
      rowkey: slug,
      email_address: params.email_address,
    }
    return ApiService.post('form-result/request-sig-email', payload)
  },
  /***
   * Create a plat customer after extracting important keys from submission
   * @param {string} slug the rowkey of the form to flag as processed
   * @returns {*}
   */
  createPlatCustomer (params) {
    return ApiService.post('platypus/create-plat-customer', params)
  },
}
export default FormResultService
